const initialState = {
    isSyncing: true
};

const syncStatusReducer = ( state = initialState, action ) => {
    switch (action.type){
        case "IS_SYNCING":
            state = {
                ...state,
                isSyncing: action.payload
            };
            break;
        case "IS_SYNC_STATE":
            state = {
                ...state,
                isSyncing: action.payload
            };
            break;
        default :
            break;
    }
    return state;
};

export default syncStatusReducer;